import { useState } from 'react';
import { FIREBASE_AUTH } from '../../../FirebaseConfig';
import { useNavigate } from 'react-router-dom';
import '../Authentication.css';


const Logout = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate()

    const signOut = async () =>{
        setLoading(true)
        try {
            const response = await FIREBASE_AUTH.signOut()
        } catch (error){
            alert("signout failed " + error.message)
            
        } finally{
            setLoading(false)
            navigate('/')
        }
    }

    return (
        <div className='auth-main-container'>
            <div className="auth-white-box">
                <h1>ARE YOU SURE YOU WISH TO LOGOUT?</h1>
                
                <button className="auth-submit-button" onClick={()=>signOut()} disabled={loading}>
                    <h2>YES</h2>
                </button>
                
                <button className="auth-submit-button" onClick={()=>navigate('/')} disabled={loading}>
                    <h2>NO</h2>
                </button>
            </div>
        </div>
    )
}

export default Logout